module.exports = __webpack_public_path__ + "static/media/ritratto.53745659.jpg";